<sdps-modal-beta [attr.sdps-title]="title" id="{{modalId}}">

  <div class="sa-delete-modal-body" slot="modal-body" *ngIf="!pendingerror">
    <div class="sdps-text-body modal-first-line">{{message}}</div>
    <div class="sdps-text-body"><strong>Type: </strong>{{transactionType}}</div>
    <div class="sdps-text-body"><strong>Nickname: </strong>{{nickname}}</div>
    <div class="sdps-text-body"><strong>To/From: </strong>{{toFrom}}</div>
    <div class="sdps-text-body"><strong>Status: </strong>{{status}}</div>
  </div>
  <div slot="modal-body" *ngIf="pendingerror">
    <div class="sdps-text-body modal-first-line">{{message}}</div>
  </div>
  <div slot="modal-footer">
    <button (click)="onCancelClick()" type="button" *ngIf="!pendingerror"
      class="sdps-button sdps-button--small sdps-button--secondary">No, go back</button>
    <button (click)="onConfirmClick()" type="button" *ngIf="!pendingerror"
      class="sdps-button sdps-button--primary sdps-button--small">{{continueButtonTxt}}</button>
      <button (click)="onCancelClick()" type="button" *ngIf="pendingerror"
      class="sdps-button sdps-button--primary sdps-button--small">OK</button>
  </div>
</sdps-modal-beta>
